import { SelectBase } from '@/components';
import clsx from 'clsx';
import styles from './SelectSort.module.scss';

const SelectSort = ({ name, items = [], selectedSorting, onChange, onOpen }) => {
	const defaultSort = items[0];
	const selectedItem = items.find(item => item.value === selectedSorting) || defaultSort;
	const headTitle = selectedItem?.name ?? '';

	return (
		<SelectBase title={headTitle} closeOnClick onOpen={onOpen}>
			{items.map(item => {
				const { name: title, value } = item;
				const isDefault = defaultSort.value === value;
				const checked = selectedItem.value === value;

				return (
					<div className={styles.item} key={value}>
						<label className={styles.radio}>
							<input
								className={styles.input}
								type='radio'
								name={name}
								value={value}
								checked={checked}
								onChange={() => onChange(isDefault ? null : value)}
							/>
							<span data-sort={title} className={clsx(styles.title, checked && styles.titleChecked)}>{title}</span>
						</label>
					</div>
				);
			})}
		</SelectBase>
	);
};

export default SelectSort;
